import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from '../../components/Header';
import { MENU } from '../../utils/constants';

export function MainLayout(): React.JSX.Element {
  return (
    <div className="main-layout">
      <Header menuItems={MENU} />
      <Outlet />
    </div>
  );
}
